



























import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  toRefs,
} from '@vue/composition-api';
import { ErrorCircleIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { LOCATION_MAP } from '@/common/reporter/utils';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';
import ipc from '@/renderer/scripts/utils/ipc';
interface VirusTemplateItem {
  theme: string;
  msg: string;
}
// 病毒查杀枚举
const detailStatusMap: Map<number, VirusTemplateItem> = new Map([
  [
    3,
    {
      theme: 'danger',
      msg: i18n_t('疑似病毒'),
    },
  ],
  [
    4,
    {
      theme: 'default',
      msg: i18n_t('未进行安全扫描'),
    },
  ],
]);
const baseStatusMap: Map<number, VirusTemplateItem> = new Map([
  [
    2,
    {
      theme: 'warning',
      msg: i18n_t('敏感文件'),
    },
  ],
  [
    3,
    {
      theme: 'danger',
      msg: i18n_t('疑似病毒'),
    },
  ],
]);

/**
 * 病毒状态标签
 * 0. 未检测 （列表不显示/ 标签
 * 1. 检测中
 * 2. 无风险（不显示）
 * 3. 风险文件（疑似病毒）
 * 4. 无法检测
 * 5. 认为标记无风险（不显示）
 * 6. 检测任务失败
 */

/**
 * 敏感词审核状态
 * 0, 未审核、无需审核
 * 1, 审核通过，未匹配敏感词，或企业无敏感词
 * 2, 审核未通过，匹配敏感词
 * 3, 手动标记无风险
 */
export default defineComponent({
  name: 'StatusTag',
  props: {
    // 详细模式（若再详细模式下，则显示更多信息）
    detail: {
      type: Boolean,
      default: false,
    },
    spaceId: {
      type: String,
      default: '',
    },
    fileItem: {
      type: Object as () => SMH.SpaceFileItemData,
      required: false,
    },
    // 病毒查杀监测状态
    virusAuditStatus: {
      type: Number,
      default: 0,
    },
    // 敏感词的检测状态
    sensitiveWordAuditStatus: {
      type: Number,
      default: 0,
    },
    // 在可疑文件中代表的可疑文件种类
    suspiciousType: {
      type: Number,
      required: false,
    },
    // 大小
    size: {
      type: String,
      default: 'medium',
    },
    // 是否可关闭(默认不打开）
    closeable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ErrorCircleIcon,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const { $route } = vm;
    const { virusAuditStatus, sensitiveWordAuditStatus, suspiciousType, fileItem, spaceId, detail } = toRefs(props);
    const confirmDialogVisible = ref<boolean>(false);
    // 病毒标签的数据(给一个默认值）
    const virusItem = computed<VirusTemplateItem | undefined>((): VirusTemplateItem | undefined => {
      // 可疑文件列表中根据suspiciousType优先展示标签 0病毒|1敏感
      if (typeof suspiciousType?.value === 'number') {
        if (suspiciousType.value === 0) return baseStatusMap.get(virusAuditStatus.value);
        if (suspiciousType.value === 1) return baseStatusMap.get(sensitiveWordAuditStatus.value);
      }
      if (virusAuditStatus.value === 3 || virusAuditStatus.value === 4) {
        if (detail.value) return detailStatusMap.get(virusAuditStatus.value);
        return baseStatusMap.get(virusAuditStatus.value);
      }
      if (virusAuditStatus.value !== 3 && sensitiveWordAuditStatus.value === 2) {
        return baseStatusMap.get(sensitiveWordAuditStatus.value);
      }
    });

    //  悬停提示信息
    const tooltipMessage = computed<string>(() => {
      if (virusAuditStatus.value === 3)
        return i18n_t('病毒名称：{slot1}', {
          slot1: fileItem?.value?.virusType,
        });
      if (sensitiveWordAuditStatus.value === 2)
        return i18n_t('内容检测不安全：内容“{slot1}”触发敏感词', {
          slot1: fileItem?.value?.sensitiveWordList?.join(','),
        });
      // 检测失败的原因
      if (virusAuditStatus.value === 4) return i18n_t('文件太大不支持检测');
      return '';
    });
    const methods = {
      async addWhite() {
        confirmDialogVisible.value = false;
        const fullPath = `${fileItem?.value?.path}/${fileItem?.value?.name}`;
        const sId = spaceId.value || ($route.query.spaceId as string) || (await spaceATM.getPersonalSpaceIdAsync());
        const pathArray = fullPath.split('/').filter(item => item !== '');
        const restoreItems: SMH.TrustFileItem[] = [
          {
            spaceId: sId,
            path: pathArray || [],
          },
        ];
        const routerName = vm.$route.name || 'teamSpace';
        try {
          let res;
          if (virusAuditStatus.value === 3) {
            res = await smh.userAPI.trustVirusFile({
              restoreItems,
            });
          } else if (sensitiveWordAuditStatus.value === 2) {
            res = await smh.userAPI.trustSensitiveFile({
              directoryList: restoreItems,
            });
            reporter.report('sensitive_manage', {
              whiten_sensitive_location: LOCATION_MAP[routerName],
              trust_name: fileItem?.value?.name,
              trust_sensitive_name: fileItem?.value?.sensitiveWordList?.join(';'),
            });
          }
          if (res?.status === 204) {
            tips.success(i18n_t('恢复成功'));
            // 刷新list
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
          }
        } catch (error: MsgError) {
          tips.error(error);
        }
      },
      close() {
        if (!fileItem?.value) return;
        confirmDialogVisible.value = true;
      },
    };
    return {
      virusItem,
      confirmDialogVisible,
      tooltipMessage,
      ...methods,
    };
  },
});
